import { useEffect, useRef, useState } from "react";

export default function Counter({ to = 0, duration = 1600, suffix = "" }) {
    const [val, setVal] = useState(0);
    const ref = useRef(null);
    const started = useRef(false);
    useEffect(() => {
        const el = ref.current;
        if (!el) return;
        const io = new IntersectionObserver(
            (entries) => {
                entries.forEach((e) => {
                    if (e.isIntersecting && !started.current) {
                        started.current = true;
                        const start = performance.now();
                        const num = parseInt(String(to).replace(/\D/g, ""), 10) || 0;
                        const step = (t) => {
                            const p = Math.min(1, (t - start) / duration);
                            const eased = 1 - Math.pow(1 - p, 3);
                            setVal(Math.round(num * eased));
                            if (p < 1) requestAnimationFrame(step);
                        };
                        requestAnimationFrame(step);
                    }
                });
            },
            { threshold: 0.4 }
        );
        io.observe(el);
        return () => io.disconnect();
    }, [to, duration]);
    return (
        <span ref={ref} className="tabular-nums">
            {val.toLocaleString("en-IN")}
            {suffix}
        </span>
    );
}
